<template>
  <NuxtLink
    :to="to"
    class="
      flex pr-1
      hover:text-red-500
    "
    :target="isExternal ? '_blank' : '_self'"
  >
    <span class="shrink-1 hyphens-auto">
      <slot />
    </span>
    <div class="ml-2 shrink-0 text-red-500">
      <IconExternalLink
        v-if="isExternal"
        class="-mr-0.5 mt-0.5 h-[0.925em]"
      />
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import type { NuxtLinkProps } from '#app'

const props = defineProps<{ to: NuxtLinkProps['to'] }>()

const isExternal = computed(() => {
  return typeof props.to === 'string' ? isExternalUrl(props.to) : false
})
</script>
